import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { zip } from 'rxjs';
import { AuthTokenService } from './auth-token.service';
import { CurrentUserService } from './current-user.service';
import { CurrentAccountService } from './current-account.service';
import { SessionDataService } from './session-data.service';

/**
 * Service for handling authentication-related operations.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private authTokenService: AuthTokenService,
    private currentUserService: CurrentUserService,
    private currentAccountService: CurrentAccountService,
    private sesssionDataService: SessionDataService,
  ) {}

  /**
   * Completes the login process by refreshing auth tokens, fetching user data,
   * and redirecting to the appropriate page.
   *
   * @param {string | null} returnUrl - The URL to redirect to after login completion
   * @returns {Promise<void>} A promise that resolves when the login completion is finished
   */
  async completeLoginAndRedirect(returnUrl: string | null = null): Promise<void> {
    // First refresh the auth tokens
    this.authTokenService.getAuthTokens(true).then(async () => {
      // Then fetch user data with fresh tokens
      await this.sesssionDataService.refresh()
      zip(
        this.currentUserService.getCurrentUser(),
        this.currentAccountService.getCurrentAccount()
      ).subscribe(([user, account]) => {
        if (user?.currentUser) {
          this.currentAccountService.updateCurrentAccount(account);
          this.currentUserService.updateCurrentUser(user);
          const target = returnUrl && returnUrl !== '/login' ? returnUrl : '/';
          this.router.navigateByUrl(target);
        } 
      });
    });
  }
}